export enum PackageAdType {
    First = 'first',
    Second = 'second',
  }